import {RepoInfo} from "../../api/types";
import {Modal} from "../Modal";
import {agent} from "../../api/agent";

interface Props {
    repo: RepoInfo;
    open: boolean;
    close: () => void;
    updateRepo: () => void;
}

export default function JobSettings({repo, open, close, updateRepo}: Props) {

    const updateVersion = (newVersion: string) => {
        agent.putRepoInfo(repo.id, {version: newVersion}).then(() => {
            updateRepo();
        });
    }
    const updateMinorBranch = (newMinorBranch: string) => {
        agent.putRepoInfo(repo.id, {minorBranch: newMinorBranch}).then(() => {
            updateRepo();
        });
    }

    return <Modal open={open} onClose={close}>
        {
            open && (
                <div style={{minWidth: '80rem', minHeight: '40rem'}}>
                    <div>
                        <label>Version: </label>
                        <input defaultValue={repo.version} onBlur={(event) => {
                            updateVersion(event.currentTarget.value);
                        }}/>
                    </div>
                    <div>
                        <label>MiniorBranch: </label>
                        <input defaultValue={repo.minorBranch} onBlur={(event) => {
                            updateMinorBranch(event.currentTarget.value);
                        }}/>
                    </div>
                </div>
            )
        }
    </Modal>;
}